import React from 'react';
import { Col, Row } from 'antd';
import { connect } from 'dva';
import type { Dispatch } from 'dva';

import styles from './index.css';
import VersionUploadForm from '../../../components/VersionUploadForm/index.js';
import type { PltUploadState } from '../../../models/pltUpload.js';

const sections = [
  ['hxrInstaller', '轻AI教学系统安装器（32位）'],
  ['hxrInstaller-win-x64', '轻AI教学系统安装器（64位）'],
  ['hxrInstaller-update', '轻AI教学系统安装器更新文件（32位）'],
  ['hxrInstaller-update-win-x64', '轻AI教学系统安装器更新文件（64位）'],
  ['plt-teacher', '轻AI教学系统（教师端）安装包（32位）'],
  ['plt-teacher-win-x64', '轻AI教学系统（教师端）安装包（64位）'],
  ['plt-student', '轻AI教学系统（学生端）安装包（32位）'],
  ['plt-student-win-x64', '轻AI教学系统（学生端）安装包（64位）'],
  ['plt-plugin-ipython', 'IPython组件'],
  ['plt-plugin-ipython-update', 'IPython更新文件'],
] as const;

interface PltUploadPageProps {
  readonly pltUpload: PltUploadState;
  readonly dispatch: Dispatch;
}

function PltUploadPage({ pltUpload, dispatch }: PltUploadPageProps): React.ReactElement {
  const versionData = pltUpload.versionData ?? {};
  const dataValues = pltUpload.dataValues ?? {};
  return (
    <div style={{ padding: '20px 20px' }}>
      <Row gutter={20}>
        {sections.map(([mode, title]) => (
          <Col span={12} key={mode}>
            <div style={{ margin: '20px 10px' }}>
              <div className={styles['title']}>{title}</div>
              <VersionUploadForm
                mode={mode}
                namespace="pltUpload"
                appVersion={mode.startsWith('hxrInstaller') ? 'hxrInstaller' : 'plt'}
                versionData={versionData}
                dataValues={dataValues}
                validExtensions={
                  mode.startsWith('plt-teacher') || mode.startsWith('plt-student')
                    ? ['msi']
                    : ['exe', 'msi', 'zip']
                }
                accept={
                  mode.startsWith('plt-teacher') || mode.startsWith('plt-student')
                    ? '.msi'
                    : '.exe,.msi,.zip'
                }
                dispatch={dispatch}
              />
            </div>
          </Col>
        ))}
      </Row>
    </div>
  );
}

const ConnectedPltUploadPage: React.ComponentType = connect(
  (state: { pltUpload: PltUploadState }) => ({ pltUpload: state.pltUpload }),
)(PltUploadPage);
export default ConnectedPltUploadPage;
